import { ApiUtility } from "./ApiUtility";

class EpubService {
  route = "/posts";
  aboutRoute = "/api/settings/aboutus?lang=";
  lastpositionRoute = "/api/user/";
  savevivekvanibookmarks = "/api/user/vivekvanimarks?vivekvaniId=";
  getvivekvanibookmarks = "/api/user/vivekvanimarks?bookId=";
  removevanimark = "/api/user/vivekvanimarks?vivekvaniId=";
  removebkmark = "/api/user/bookmarks?bookId=";
  getbkmark = "/api/user/bookmarks?BookId=";
  refreshtoken = "/api/user/RefreshTokenV2"

  getAboutData = (lang: string) => {
    return ApiUtility.get(this.aboutRoute + lang);
  };

  SaveLastPositionAndClose = (
    lstposition: string,
    bookId: string,
    last_cfi: string,
    bookfontsize: string,
    navorder?: string
  ) => {
    console.log("last_cfi in EpubService:", last_cfi);
    console.log("bookId in EpubService:", bookId);
    console.log("bookfontsize in EpubService:", bookfontsize);
    console.log("navorder in EpubService:", navorder);
    console.log("lstposition in EpubService:", lstposition);

    let url = this.lastpositionRoute +
      lstposition +
      "?bookId=" +
      bookId +
      "&cfi=" +
      last_cfi +
      "&bookfontsize=" +
      bookfontsize;
    if (navorder) {
      url += "&navorder=" + navorder;
    }
    return ApiUtility.post(url, {});
  };

  savebookmark = (
    bookmarkposition: string,
    bookId: string,
    cfi: string,
    chaptername: string
  ) => {
    return ApiUtility.post(
      this.lastpositionRoute +
      bookmarkposition +
      "?bookId=" +
      bookId +
      "&cfi=" +
      cfi +
      "&chaptername=" +
      chaptername,
      {}
    );
  };

  savevivekvanimark = (
    bookId: string,
    cfi: string,
    chaptername: string
  ) => {
    return ApiUtility.post(
      this.savevivekvanibookmarks +
      bookId +
      "&cfi=" +
      cfi +
      "&chaptername=" +
      chaptername,
      {}
    );
  };

  getvivekvanimark = (bookId: string) => {
    return ApiUtility.get(this.getvivekvanibookmarks + bookId);
  };

  deletevivekmark(bookmarkposition: string, bookId: string, cfi: string) {
    return ApiUtility.delete(this.removevanimark + bookId + "&cfi=" + cfi);
  }

  removebookmark(bookmarkposition: string, bookId: string, cfi: string) {
    return ApiUtility.delete(this.lastpositionRoute + bookmarkposition + "?bookId=" + bookId + "&cfi=" + cfi);
  }

  getbookmark = (bookmarkposition: string, bookId: string) => {
    return ApiUtility.get(this.lastpositionRoute + bookmarkposition + "?bookId=" + bookId);
  };

  getLastPosition(lstposition: string, bookId: string) {
    return ApiUtility.get(this.lastpositionRoute + lstposition + "?bookId=" + bookId);
  }

  refreshexpiredtoken = (
    userId: string,
    medium: 1,
    fcmToken: string
  ) => {
    return ApiUtility.post(
      this.refreshtoken,
      {
        userId: userId,
        medium: 1,
        fcmToken: fcmToken
      },
    );
  };
}

export default new EpubService();